<section
  class="sub-header"
  data-aos="fade"
  data-aos-duration="1500"
  data-aos-easing="ease-in"
  [style.background-image]="'url(' + healthEducation?.foregroundImage"
></section>
<section class="ptb-25 bg-gray3 text-primary">
  <div class="container">
    <div
      class="section-title w-100 max-700 m-auto mrb-15 text-center weight-700 size-md-35 size-10"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      {{ healthEducation?.title || healthEducation?.titleAr }}
    </div>
    <!-- <div class="text-center max-height-600">
      <img
        class="covid19-img"
        [src]="healthEducation?.foregroundImage"
        alt="img"
      />
    </div> -->
    <div
      class="mrb-10 mrt-30 size-8"
      data-aos="fade-up"
      data-aos-duration="1500"
      [innerHtml]="healthEducation?.body || healthEducation?.bodyAr"
    ></div>
  </div>
</section>

<section class="text-primary ptb-25 bg-gray3">
  <div class="container">
    <div
      class="section-title mrb-15 text-center weight-700 size-15"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      {{ "readAlso" | translate }}
    </div>
    <div class="row">
      <div
        class="col-12 col-md-6 col-lg-4"
        data-aos="fade-up"
        data-aos-duration="1500"
        *ngFor="let health of healtEducationsByCategory"
      >
        <a
          [routerLink]="[
            '/health-education',
            health?.healthEducationCategoryId
          ]"
        >
          <health-education
            [title]="health?.title || health?.titleAr"
            [image]="health?.foregroundImage"
            [healthEducationId]="health?.healthEducationId"
          ></health-education>
        </a>
      </div>
    </div>
  </div>
</section>
